import { render } from "./rooms-on-rent.vue?vue&type=template&id=44af5995"
import script from "./rooms-on-rent.vue?vue&type=script&lang=js"
export * from "./rooms-on-rent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__